import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {
        // 获取检测进度下拉列表GET /api/Option/GetOptionByModId
        GetOptionByModId(ModuleId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ModuleId: ModuleId
            };
            this.loading = true;
            $http.get("api/Option/GetOptionByModId", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.OptionTypes = Data
                });
            });
        },
        // 获取检测结果下拉列表GET api/Option/GetOptionDetailByOptionId
        GetOptionDetailByOptionId(OptionId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OptionId: OptionId
            };
            this.loading = true;
            $http.get("api/Option/GetOptionDetailByOptionId", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.CheckResult = Data
                });
            });
        },
        // 跟进POST /api/NetWorkCheck/AddNetCheckFollow
        AddNetCheckFollow() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            params = Object.assign({}, params, this.form);
            $http.post('api/NetWorkCheck/AddNetCheckFollowEx', params).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.$emit('reloadList')
                    this.close()
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/components/followDialog/services.js